<template>
  <img v-if="avatarSrc?.length" :src="avatarSrc" :style="{ width: `${width}px`, height: `${height}px` }" class="object-cover rounded flex-shrink-0" />
  <div v-else :style="{ width: `${width}px`, height: `${height}px` }" class="rounded flex items-center justify-center bg-neutral-alpha-300 flex-shrink-0">
    <BaseText type="label" :size="fontSize" class="text-neutral-alpha-600 uppercase">
      {{ getAvatarPlaceholderInitials(lensName) }}
    </BaseText>
  </div>
</template>

<script>
export default {
  name: 'LensAvatar',
  props: {
    avatarSrc: {
      type: String,
      default: ''
    },
    lensName: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 32
    },
    height: {
      type: Number,
      default: 32
    },
    fontSize: {
      type: String,
      default: 'sm'
    }
  },
  methods: {
    getAvatarPlaceholderInitials (name) {
      if (!name) return 'L'
      return name.split(' ').map(n => n[0]).join('').slice(0, 2)
    }
  }
}
</script>